import React, { useState } from "react";
import "./index.scss";
import { Box, Button, Grid2, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ConcertDetails from "components/concert/concertDetails";
import useInfoContext from "hooks/useInfoContext";
import CustomModalConfirm from "components/modalConfirm";

const AcceptingRules = () => {
  const [pageStatus, setPageStatus] = useState("step1");
  const [isChecked, setIsChecked] = useState(false);
  const [openModalRegister, setOpenModalRegister] = useState(false);
  const navigate = useNavigate();
  const { itemEventDetail, userInfo } = useInfoContext();

  const confirmRegister = () => {
    navigate("/national-id?register-concert");
  };

  const handleContinue = () => {
    if (pageStatus === "step1") {
      if (userInfo?.nationalId) {
        setPageStatus("step2");
      } else {
        setOpenModalRegister(true);
      }
    } else {
      navigate("/register-concert");
    }
  };

  return (
    <Box className="container-accepting">
      <Grid2 container columns={12} className="grid-box">
        <Grid2 item size={{ xs: 12 }} className="top-box">
          {pageStatus === "step1" && (
            <>
              <ConcertDetails />
              <Box className="parent-locations">
                <Grid2 item size={{ xs: 12 }} style={{ height: "230px" }}>
                  <iframe
                    title="Google Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.2403961951622!2d51.402634!3d35.7203059!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e013a5236a607%3A0x86ea2c135f8d889!2sMinistry%20of%20Interior%20Hall!5e0!3m2!1sen!2s!4v1736239561908!5m2!1sen!2s"
                    width="100%"
                    height="100%"
                    style={{ border: "0", borderRadius: "10px" }}
                    allowFullScreen=""
                    loading="lazy"
                  ></iframe>
                </Grid2>
                <Typography variant="h6" className="address-text">
                  <span className="dot"></span>
                  تهران، میدان فاطمی ، خیابان شهید گمنام
                </Typography>
              </Box>
            </>
          )}
          {pageStatus === "step2" && (
            <Grid2 item size={{ xs: 12 }} className="parent-rules">
              <Typography variant="h6">
                {itemEventDetail.terms.split("@@").map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </Typography>
            </Grid2>
          )}
        </Grid2>
        <Grid2 item size={{ xs: 12 }} className="bottom-continue-accpecting">
          {pageStatus === "step2" && (
            <Box className="box-checkbox">
              <input
                type="checkbox"
                className="checkbox-input"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
              />
              <Typography variant="h6">قوانین و مقررات رو می پذیرم</Typography>
            </Box>
          )}
          <Button
            variant="contained"
            className={`${
              pageStatus === "step1"
                ? "button-continue"
                : pageStatus === "step2" && !isChecked
                ? "disable-button"
                : "button-continue"
            }`}
            onClick={handleContinue}
            disabled={pageStatus === "step2" && !isChecked}
          >
            {pageStatus === "step1" ? "ادامه" : "تایید شرکت در کنسرت"}
          </Button>
        </Grid2>
      </Grid2>
      <CustomModalConfirm
        open={openModalRegister}
        handleClose={setOpenModalRegister}
        textTitle="برای شرکت در کنسرت شهرام شکوهی نیاز به احراز هویت می باشد"
        textConfirmButton="احراز هویت"
        textCancleButton="لغو"
        functionConfirm={confirmRegister}
      />
    </Box>
  );
};

export default AcceptingRules;
